"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
const mithril_1 = __importDefault(require("mithril"));
exports.Tabs = {
    view(vnode) {
        let attrs = vnode.attrs;
        let selectedPane = attrs.selected;
        let klass = attrs.class || "";
        let hook = attrs.ontabchange;
        let ontabchange = function (target) {
            return function (evt) {
                evt.preventDefault();
                if (hook)
                    hook(target);
            };
        };
        klass += " tabs";
        let newAttrs = Object.assign({}, attrs, { class: klass });
        let displayChild;
        let children = vnode.children;
        let elms = [];
        if (children && children instanceof Array) {
            children.forEach((element) => {
                if (element && element.key) {
                    let key = element.key;
                    let elm;
                    if (element.attrs) {
                        elm = element.attrs.dataLabel || element.key;
                    }
                    else {
                        elm = element.key;
                    }
                    elms.push((0, mithril_1.default)("li", {
                        class: (selectedPane == key) ? "is-active" : ""
                    }, (0, mithril_1.default)("a", { onclick: ontabchange(key) }, elm)));
                    if (key == selectedPane) {
                        displayChild = element;
                    }
                }
            });
        }
        return [(0, mithril_1.default)("div", newAttrs, (0, mithril_1.default)("ul", elms)), displayChild];
    }
};
